import React from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';

const PaymentHistory: React.FC = () => {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Zahlungsverlauf
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Diese Funktion wird in Kürze verfügbar sein.
      </Alert>
      <Paper elevation={1} sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Hier werden Sie bald Ihre vollständige Zahlungshistorie einsehen können.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PaymentHistory;
